export const getNotificationConfirmationData = (action, count, translations) => {
  const requestText =
    count === 1 ? translations?.confirmSingleRequest : translations?.confirmMultipleRequests

  return {
    header: `${action} Selected Requests`,
    body: requestText.replace('{action}', `"${action}"`).replace('{count}', count),
    cancelText: 'Back',
    confirmText: `Yes, ${action}`,
    color: action === 'approve' ? '#29CC8B' : '#FC5A5A',
  }
}
export const selectRequestInboxModalData = (action, employeeName, requestType, translations) => ({
  header: `${action} a Request`,
  body: translations?.confirmVacationRequest
    .replace('{action}', `"${action}"`)
    .replace('{requestType}', requestType)
    .replace('{employeeName}', employeeName),
  cancelText: 'No',
  confirmText: `Yes, ${action}`,
  color: action === 'approve' ? '#29cc8b' : '#ff6f61',
})

export const importUsersRolesModalData = {
  header: 'Import User\'s Roles',
  body: 'Are you sure you want to import the file you uploaded to user\'s roles ?',
  subBody: 'Once Confirmed, You can\'t undo this action anymore.',
  cancelText: 'back',
  confirmText: 'Yes, Import',
}

export const resetUserPasswordConfirmationData = (t) => ({
  title: t?.['Reset User Password'],
  color: '#000',
  header: t?.['Reset User Password'],
  body: t?.['Are you sure you want to \'Reset\' this user password?'],
  finish: t?.['Reset mail has been sent successfully'],
  error: t?.['Could not Reset this user password'],
})
